<template>
    <div
        class="absolute bottom-12 right-4 flex items-center gap-2 text-sm md:bottom-4"
    >
        <div class="map-controls-section">
            <NuxtLink
                v-tooltip.top="$t('general.tooltip_error_report')"
                :to="`mailto:uap@ipr.praha.eu?subject=Katalog lokalit - hlášení chyby`"
            >
                <button
                    type="button"
                    class="hover:text-blue-text group size-7 items-center bg-white px-2 2xl:size-8 2xl:p-2"
                >
                    <!-- <img src="@/assets/img/home-button.svg" /> -->
                    <span
                        class="esri-icon esri-icon-notice-triangle flex group-hover:font-bold"
                    />
                </button>
            </NuxtLink>
        </div>

        <div class="map-controls-section">
            <div
                ref="scalebar"
                class="flex h-7 items-center px-3 font-light 2xl:h-8"
            />
            <!-- <scale-select class="scale-widget" /> -->
        </div>
        <div class="map-controls-section">
            <button
                v-tooltip.top="$t('klok.zoom_in')"
                type="button"
                class="hover:text-blue-text group flex size-7 items-center justify-center border-r border-black-text 2xl:size-8"
                @click="zoomIn()"
            >
                <!-- <img src="@/assets/img/plus.svg" /> -->
                <span
                    class="esri-icon esri-icon-plus flex text-sm group-hover:font-bold"
                />
            </button>
            <button
                v-tooltip.top="$t('klok.zoom_out')"
                type="button"
                class="hover:text-blue-text group flex size-7 items-center justify-center 2xl:size-8"
                @click="zoomOut()"
            >
                <!-- <img src="@/assets/img/minus.svg" /> -->
                <span
                    class="esri-icon esri-icon-minus flex text-sm group-hover:font-bold"
                />
            </button>
        </div>
        <div class="map-controls-section">
            <button
                v-tooltip.top="$t('klok.home_button')"
                type="button"
                class="hover:text-blue-text group size-7 items-center bg-white 2xl:size-8"
                @click="goHome"
            >
                <!-- <img src="@/assets/img/home-button.svg" /> -->
                <span
                    class="esri-icon esri-icon-home flex group-hover:font-bold"
                />
            </button>
        </div>
    </div>
    <div
        class="absolute bottom-24 right-4 w-52 border border-black-text bg-white p-2 md:bottom-16 md:w-60"
    >
        <div class="flex justify-between text-xs md:text-sm">
            <div class="">
                {{ $t("klok.pruhlednost") }}
            </div>
            <!-- <div class="">{{ Math.round(store.layerOpacity * 100) }}%</div> -->
        </div>
        <div class="relative my-2 px-2">
            <Slider
                v-model="store.layerOpacity"
                :min="0"
                :max="1"
                :step="0.01"
                class="w-full"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import ScaleBar from "@arcgis/core/widgets/ScaleBar"
import ZoomVM from "@arcgis/core/widgets/Zoom/ZoomViewModel"

const store = useKlokStore()

let homePosition: __esri.Point | undefined = undefined
let scale = 0

let zoomVM: ZoomVM | undefined = undefined

const scalebar = ref<HTMLDivElement | null>(null)

onMounted(() => {
    const view = getKlokView()
    if (view && scalebar.value) {
        homePosition = view.center
        scale = view.scale
        new ScaleBar({
            container: scalebar.value,
            view,
            unit: "metric",
        })
        zoomVM = new ZoomVM({
            view,
            canZoomIn: true,
            canZoomOut: true,
        })
    }
})

const zoomIn = () => {
    if (zoomVM) {
        zoomVM.zoomIn()
    }
}
const zoomOut = () => {
    if (zoomVM) {
        zoomVM.zoomOut()
    }
}

const goHome = () => {
    const view = getKlokView()
    if (view) {
        view.goTo({
            center: homePosition,
            scale,
        })
    }
}
</script>

<style lang="scss" scoped>
.map-controls {
    @apply absolute bottom-14 right-4 flex items-center gap-2 md:bottom-6 md:right-6 2xl:bottom-4 2xl:right-4;

    .ipr-tooltip {
        &:hover {
            button {
                @apply bg-gray-100;
            }
        }
    }
}
.map-controls-section {
    @apply flex items-center border border-black-text bg-white;
    button {
        @apply flex items-center justify-center bg-transparent;
        @apply m-0 h-7 w-7 rounded-none hover:font-bold hover:text-hover-link 2xl:h-8 2xl:w-8;
        span {
            @apply text-sm;
        }
    }
    :deep(.esri-scale-bar__label-container--line) {
        @apply relative bottom-auto left-auto right-auto pl-1;
    }
    :deep(.esri-scale-bar__label) {
        @apply pt-0.5 text-xs font-normal;
    }
    :deep(.esri-scale-bar__line--top) {
        @apply -top-px before:h-4 after:h-4;
    }
}
</style>
